var _defs, _symbol;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "logout",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M21 12v-5c0-0.796-0.316-1.559-0.879-2.121s-1.326-0.879-2.121-0.879h-8c-0.796 0-1.559 0.316-2.121 0.879s-0.879 1.326-0.879 2.121v18c0 0.796 0.316 1.559 0.879 2.121s1.326 0.879 2.121 0.879h8c0.796 0 1.559-0.316 2.121-0.879s0.879-1.326 0.879-2.121v-5M25 20l4-4M29 16l-4-4M29 16h-17"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "upload",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M4 22v3c0 0.796 0.316 1.559 0.879 2.121s1.326 0.879 2.121 0.879h18c0.796 0 1.559-0.316 2.121-0.879s0.879-1.326 0.879-2.121v-3M10 10l6-6M16 4l6 6M16 4v18"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "calendar",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.6,
    d: "M9 4v3M23 4v3M4 25v-15c0-0.796 0.316-1.559 0.879-2.121s1.326-0.879 2.121-0.879h18c0.796 0 1.559 0.316 2.121 0.879s0.879 1.326 0.879 2.121v15M4 25c0 0.796 0.316 1.559 0.879 2.121s1.326 0.879 2.121 0.879h18c0.796 0 1.559-0.316 2.121-0.879s0.879-1.326 0.879-2.121M4 25v-10c0-0.796 0.316-1.559 0.879-2.121s1.326-0.879 2.121-0.879h18c0.796 0 1.559 0.316 2.121 0.879s0.879 1.326 0.879 2.121v10M16 17h0.011v0.011h-0.011v-0.011zM16 20h0.011v0.011h-0.011v-0.011zM16 23h0.011v0.011h-0.011v-0.011zM13 20h0.011v0.011h-0.011v-0.011zM13 23h0.011v0.011h-0.011v-0.011zM10 20h0.011v0.011h-0.011v-0.011zM10 23h0.011v0.011h-0.011v-0.011zM19 17h0.011v0.011h-0.011v-0.011zM19 20h0.011v0.011h-0.011v-0.011zM19 23h0.011v0.011h-0.011v-0.011zM22 17h0.011v0.011h-0.011v-0.011zM22 20h0.011v0.011h-0.011v-0.011z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-down",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.706 21.707c-0.187 0.187-0.442 0.293-0.707 0.293s-0.519-0.105-0.707-0.293l-10-10c-0.177-0.19-0.273-0.44-0.268-0.699s0.11-0.506 0.293-0.689c0.183-0.183 0.43-0.288 0.689-0.293s0.51 0.092 0.699 0.268l9.293 9.293 9.293-9.293c0.092-0.098 0.202-0.177 0.325-0.232s0.255-0.084 0.389-0.086c0.134-0.002 0.268 0.022 0.392 0.073s0.238 0.125 0.333 0.22 0.17 0.208 0.22 0.333c0.050 0.125 0.075 0.258 0.073 0.392s-0.032 0.267-0.086 0.389-0.133 0.233-0.232 0.325l-10 10z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "settings",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M12.792 5.253c0.12-0.723 0.747-1.253 1.48-1.253h3.457c0.733 0 1.36 0.531 1.48 1.253l0.284 1.708c0.084 0.499 0.417 0.915 0.86 1.16 0.099 0.053 0.196 0.111 0.293 0.169 0.432 0.261 0.96 0.343 1.433 0.165l1.623-0.608c0.333-0.125 0.699-0.128 1.033-0.008s0.616 0.354 0.793 0.662l1.728 2.996c0.177 0.308 0.24 0.668 0.177 1.018s-0.249 0.665-0.523 0.89l-1.337 1.103c-0.391 0.32-0.584 0.817-0.575 1.323 0.002 0.113 0.002 0.227 0 0.34-0.009 0.504 0.184 1 0.573 1.32l1.34 1.104c0.565 0.467 0.712 1.272 0.347 1.907l-1.731 2.996c-0.177 0.307-0.458 0.542-0.793 0.662s-0.7 0.117-1.033-0.007l-1.623-0.608c-0.473-0.177-1-0.096-1.435 0.165-0.097 0.059-0.194 0.116-0.293 0.171-0.441 0.244-0.775 0.66-0.859 1.159l-0.284 1.707c-0.12 0.724-0.747 1.255-1.48 1.255h-3.459c-0.733 0-1.36-0.531-1.48-1.253l-0.284-1.708c-0.083-0.499-0.416-0.915-0.859-1.16-0.099-0.055-0.197-0.111-0.293-0.169-0.433-0.261-0.96-0.343-1.435-0.165l-1.623 0.608c-0.332 0.125-0.698 0.127-1.032 0.008s-0.615-0.354-0.793-0.661l-1.729-2.996c-0.177-0.308-0.24-0.668-0.176-1.018s0.249-0.665 0.523-0.89l1.339-1.103c0.389-0.32 0.583-0.817 0.573-1.323-0.002-0.113-0.002-0.227 0-0.34 0.009-0.504-0.184-1-0.573-1.32l-1.339-1.104c-0.274-0.225-0.459-0.541-0.523-0.89s-0.001-0.709 0.176-1.017l1.729-2.996c0.178-0.308 0.459-0.543 0.793-0.662s0.701-0.117 1.033 0.008l1.621 0.608c0.475 0.177 1.001 0.096 1.435-0.165 0.096-0.059 0.195-0.116 0.293-0.171 0.443-0.244 0.776-0.66 0.859-1.159l0.285-1.708z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M20 16c0 1.061-0.421 2.078-1.172 2.828s-1.768 1.172-2.828 1.172c-1.061 0-2.078-0.421-2.828-1.172s-1.172-1.768-1.172-2.828c0-1.061 0.421-2.078 1.172-2.828s1.768-1.172 2.828-1.172c1.061 0 2.078 0.421 2.828 1.172s1.172 1.768 1.172 2.828z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "eye",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M2.715 16.429c-0.092-0.277-0.092-0.575 0-0.852 1.849-5.564 7.099-9.577 13.285-9.577 6.184 0 11.431 4.009 13.284 9.571 0.093 0.276 0.093 0.575 0 0.852-1.848 5.564-7.097 9.577-13.284 9.577-6.184 0-11.432-4.009-13.285-9.571z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M20 16c0 1.061-0.421 2.078-1.172 2.828s-1.768 1.172-2.828 1.172c-1.061 0-2.078-0.421-2.828-1.172s-1.172-1.768-1.172-2.828c0-1.061 0.421-2.078 1.172-2.828s1.768-1.172 2.828-1.172c1.061 0 2.078 0.421 2.828 1.172s1.172 1.768 1.172 2.828z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "hidden",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M5.307 10.964c-1.247 1.472-2.176 3.187-2.728 5.036 1.723 5.784 7.080 10 13.421 10 1.324 0 2.604-0.184 3.817-0.527M8.304 8.304c2.284-1.507 4.96-2.308 7.696-2.304 6.341 0 11.697 4.216 13.42 9.997-0.944 3.159-2.971 5.885-5.724 7.699M8.304 8.304l-4.304-4.304M8.304 8.304l4.867 4.867M23.696 23.696l4.304 4.304M23.696 23.696l-4.867-4.867c0.371-0.371 0.666-0.812 0.867-1.298s0.304-1.005 0.304-1.531-0.103-1.045-0.304-1.531c-0.201-0.485-0.496-0.926-0.867-1.298s-0.813-0.666-1.298-0.867c-0.485-0.201-1.005-0.304-1.531-0.304s-1.046 0.103-1.531 0.305c-0.485 0.201-0.926 0.496-1.298 0.867M18.828 18.828l-5.655-5.655"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "minus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 16c0-0.265 0.105-0.52 0.293-0.707s0.442-0.293 0.707-0.293h16c0.265 0 0.52 0.105 0.707 0.293s0.293 0.442 0.293 0.707-0.105 0.52-0.293 0.707c-0.187 0.188-0.442 0.293-0.707 0.293h-16c-0.265 0-0.52-0.105-0.707-0.293s-0.293-0.442-0.293-0.707z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "note",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M22.483 5.983l2.249-2.251c0.469-0.469 1.105-0.732 1.768-0.732s1.299 0.263 1.768 0.732c0.469 0.469 0.732 1.105 0.732 1.768s-0.263 1.299-0.732 1.768l-14.159 14.159c-0.705 0.705-1.574 1.222-2.529 1.507l-3.58 1.067 1.067-3.58c0.284-0.955 0.802-1.824 1.507-2.529l11.909-11.908zM22.483 5.983l3.517 3.517M24 18.667v6.333c0 0.796-0.316 1.559-0.879 2.121s-1.326 0.879-2.121 0.879h-14c-0.796 0-1.559-0.316-2.121-0.879s-0.879-1.326-0.879-2.121v-14c0-0.796 0.316-1.559 0.879-2.121s1.326-0.879 2.121-0.879h6.333"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "add",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M16 12v8M20 16h-8M28 16c0 1.576-0.31 3.136-0.913 4.592s-1.487 2.779-2.601 3.893c-1.114 1.114-2.437 1.998-3.893 2.601s-3.016 0.913-4.592 0.913-3.136-0.31-4.592-0.913c-1.456-0.603-2.779-1.487-3.893-2.601s-1.998-2.437-2.601-3.893c-0.603-1.456-0.913-3.016-0.913-4.592 0-3.183 1.264-6.235 3.515-8.485s5.303-3.515 8.485-3.515c3.183 0 6.235 1.264 8.485 3.515s3.515 5.303 3.515 8.485z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M16 8v16M24 16h-16"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "graphic",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.6,
    d: "M5 4v15c0 0.796 0.316 1.559 0.879 2.121s1.326 0.879 2.121 0.879h3M5 4h-2M5 4h22M11 22h10M11 22l-1.333 4M27 4h2M27 4v15c0 0.796-0.316 1.559-0.879 2.121s-1.326 0.879-2.121 0.879h-3M21 22l1.333 4M9.667 26h12.667M9.667 26l-0.667 2M22.333 26l0.667 2M12 15v2M16 12v5M20 9v8"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "remove",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M19.653 12l-0.461 12M12.808 24l-0.461-12M25.637 7.72c0.456 0.069 0.909 0.143 1.363 0.221M25.637 7.72l-1.424 18.511c-0.058 0.754-0.399 1.458-0.953 1.971s-1.283 0.799-2.039 0.798h-10.443c-0.756 0-1.484-0.285-2.039-0.798s-0.895-1.217-0.953-1.971l-1.424-18.511M25.637 7.72c-1.539-0.233-3.086-0.409-4.637-0.529M6.363 7.72c-0.456 0.068-0.909 0.141-1.363 0.22M6.363 7.72c1.539-0.233 3.086-0.409 4.637-0.529M21 7.191v-1.221c0-1.573-1.213-2.885-2.787-2.935-1.475-0.047-2.951-0.047-4.427 0-1.573 0.049-2.787 1.363-2.787 2.935v1.221M21 7.191c-3.328-0.257-6.672-0.257-10 0"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "user",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M31.333 16c0 8.468-6.865 15.333-15.333 15.333s-15.333-6.865-15.333-15.333c0-8.468 6.865-15.333 15.333-15.333s15.333 6.865 15.333 15.333z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.3333,
    d: "M20.001 9.436c0 1.088-0.421 2.132-1.172 2.901s-1.768 1.202-2.829 1.202c-1.061 0-2.079-0.432-2.829-1.202s-1.172-1.813-1.172-2.901c0-1.088 0.421-2.132 1.172-2.901s1.768-1.202 2.829-1.202c1.061 0 2.079 0.432 2.829 1.202s1.172 1.813 1.172 2.901zM8 24.881c0.034-2.153 0.892-4.205 2.389-5.715s3.512-2.356 5.611-2.356c2.099 0 4.115 0.846 5.611 2.356s2.355 3.562 2.389 5.715c-2.51 1.18-5.239 1.789-8 1.785-2.855 0-5.564-0.639-8-1.785z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "tools",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.6,
    d: "M15.227 20.227l7.773 7.773c0.667 0.645 1.56 1.003 2.488 0.995s1.816-0.379 2.472-1.036c0.656-0.656 1.028-1.544 1.036-2.472s-0.35-1.821-0.995-2.488l-7.836-7.836M15.227 20.227l3.328-4.040c0.423-0.512 0.987-0.835 1.611-1.021 0.733-0.219 1.551-0.251 2.324-0.187 1.042 0.090 2.090-0.095 3.039-0.536s1.766-1.121 2.371-1.975 0.975-1.851 1.076-2.893c0.1-1.041-0.074-2.091-0.504-3.045l-4.368 4.369c-0.731-0.169-1.399-0.54-1.93-1.070s-0.901-1.199-1.070-1.93l4.368-4.368c-0.954-0.431-2.003-0.605-3.044-0.504s-2.039 0.471-2.893 1.076-1.535 1.422-1.975 2.371c-0.44 0.949-0.625 1.997-0.536 3.039 0.121 1.435-0.095 3.019-1.205 3.933l-0.136 0.113M15.227 20.227l-6.207 7.537c-0.301 0.367-0.675 0.666-1.099 0.88s-0.887 0.336-1.361 0.359c-0.474 0.023-0.947-0.053-1.39-0.224s-0.844-0.432-1.18-0.767-0.597-0.737-0.767-1.18c-0.171-0.442-0.247-0.916-0.223-1.39s0.146-0.937 0.359-1.361c0.213-0.424 0.513-0.798 0.88-1.099l9.116-7.507-5.476-5.476h-1.879l-3-5 2-2 5 3v1.879l5.68 5.68-2.327 1.916M24.5 24.5l-3.5-3.5M6.489 25.5h0.011v0.011h-0.011v-0.011z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-left",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.706 10.293c0.187 0.188 0.292 0.442 0.292 0.707s-0.105 0.519-0.292 0.707l-3.293 3.293h21.587c0.265 0 0.52 0.105 0.707 0.293s0.293 0.442 0.293 0.707c0 0.265-0.105 0.519-0.293 0.707s-0.442 0.293-0.707 0.293h-21.587l3.293 3.293c0.098 0.091 0.177 0.202 0.232 0.325s0.084 0.255 0.086 0.389c0.002 0.134-0.022 0.268-0.073 0.392s-0.125 0.238-0.22 0.333-0.208 0.17-0.333 0.22c-0.125 0.050-0.258 0.075-0.392 0.073s-0.267-0.032-0.389-0.086-0.233-0.133-0.325-0.232l-5-5c-0.187-0.188-0.292-0.442-0.292-0.707s0.105-0.519 0.292-0.707l5-5c0.188-0.187 0.442-0.292 0.707-0.292s0.519 0.105 0.707 0.292z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Ellipse",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "close",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 18L18 6M6 6L18 18",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "x-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.734 10.304l-1.504-1.504-5.963 5.962-5.962-5.962-1.504 1.504 5.962 5.962-5.962 5.963 1.504 1.504 5.962-5.963 5.963 5.963 1.504-1.504-5.963-5.963 5.963-5.962z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-down",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.706 21.707a1.002 1.002 0 0 1-1.414 0l-10-10a.996.996 0 0 1 .025-1.388 1.002 1.002 0 0 1 1.388-.025l9.293 9.293 9.293-9.293a1.013 1.013 0 0 1 .714-.318.993.993 0 0 1 .725.293.992.992 0 0 1 .293.725 1.001 1.001 0 0 1-.318.714l-10 10z"
  })))), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "logout",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.333,
    d: "M21 12V7a3.004 3.004 0 0 0-3-3h-8a3.004 3.004 0 0 0-3 3v18a3.004 3.004 0 0 0 3 3h8a3.004 3.004 0 0 0 3-3v-5m4 0 4-4m0 0-4-4m4 4H12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.8476dedb89b35a4c19f1b1930224c49a.svg";
export { ForwardRef as ReactComponent };